import { render, staticRenderFns } from "./PenwiseWeight.vue?vue&type=template&id=8b0b770c&scoped=true"
import script from "./PenwiseWeight.vue?vue&type=script&lang=js"
export * from "./PenwiseWeight.vue?vue&type=script&lang=js"
import style0 from "./PenwiseWeight.vue?vue&type=style&index=0&id=8b0b770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0b770c",
  null
  
)

export default component.exports